import * as Yup from "yup";

const ValidationEditUser = Yup.object().shape({
  name: Yup.string().required("El campo es requerido"),
  lastName: Yup.string().required("El campo es requerido"),
});

export default ValidationEditUser;
